import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Selectors from 'src/state/root-selectors';

import { ENTITLED_NAV, UNENTITLED_NAV } from '../components/layout/header/nav-constants';

const filterNavItems = (navItems, partner) =>
    navItems.map((topNavElement) => {
        topNavElement.subnav = topNavElement.subnav?.filter((el) => {
            if (!el.filters) {
                return el;
            }

            return !el.filters.includes(partner);
        });

        return topNavElement;
    });

const useNavItems = () => {
    const [navItems, setNavItems] = useState([]);

    const userAttr = useSelector((state) => Selectors.account?.userAttributes(state));
    const partner = userAttr?.object?.partner?.provider;

    const loggedIn = useSelector((state) => Selectors.auth.loggedIn(state));
    const entitled = useSelector((state) => Selectors.config.shopifyUrl(state));
    const shopifyUrl = useSelector((state) => Selectors.config.shopifyUrl(state));

    useEffect(() => {
        const NAV_ITEMS = entitled
            ? ENTITLED_NAV(loggedIn && entitled, shopifyUrl)
            : UNENTITLED_NAV(shopifyUrl);

        const filterd = !loggedIn ? NAV_ITEMS : filterNavItems(NAV_ITEMS, partner);

        setNavItems(filterd);
    }, [loggedIn, entitled, shopifyUrl, partner]);

    return navItems;
};

export default useNavItems;
